import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=fc5670ae&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc5670ae')) {
      api.createRecord('fc5670ae', component.options)
    } else {
      api.reload('fc5670ae', component.options)
    }
    module.hot.accept("./wallet.vue?vue&type=template&id=fc5670ae&", function () {
      api.rerender('fc5670ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/wallet.vue"
export default component.exports